import Avatar from '@mui/material/Avatar';

const initials = (name: string) => name.split(/\s+/).filter(Boolean).map((p) => p[0]).join('').slice(0, 2).toUpperCase();

/** Same name, same colour, wherever the person appears. */
const tintIndex = (name: string, count: number) => {
  let hash = 7;
  for (let i = 0; i < name.length; i += 1) hash = (hash * 31 + name.charCodeAt(i)) >>> 0;
  return hash % count;
};

type Props = { name: string; size?: number; ring?: boolean };

/** Initials on a soft tint. `ring` adds a white outline so overlapping avatars stay apart. */
export function PersonAvatar({ name, size = 22, ring = false }: Props) {
  return (
    <Avatar
      aria-hidden
      sx={(t) => {
        const tint = t.palette.tints[tintIndex(name, t.palette.tints.length)] ?? { bg: t.palette.surface.sunken, fg: t.palette.text.secondary };
        return {
          width: size,
          height: size,
          fontSize: Math.round(size * 0.4),
          fontWeight: 600,
          bgcolor: tint.bg,
          color: tint.fg,
          border: ring ? `1.5px solid ${t.palette.background.paper}` : 'none',
        };
      }}
    >
      {initials(name)}
    </Avatar>
  );
}
